var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#38879F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9997 54.2298C30.5988 54.2298 23.7705 47.4015 23.7705 39.0007C23.7705 30.5998 30.5988 23.7715 38.9997 23.7715C47.4005 23.7715 54.2288 30.5998 54.2288 39.0007C54.2288 47.4015 47.4005 54.2298 38.9997 54.2298ZM38.9997 25.8965C31.7747 25.8965 25.8955 31.7757 25.8955 39.0007C25.8955 46.2257 31.7747 52.1048 38.9997 52.1048C46.2247 52.1048 52.1038 46.2257 52.1038 39.0007C52.1038 31.7757 46.2247 25.8965 38.9997 25.8965Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.988 44.0719C36.7047 44.0719 36.4355 43.9586 36.2372 43.7603L32.228 39.7511C31.8172 39.3403 31.8172 38.6603 32.228 38.2494C32.6389 37.8386 33.3189 37.8386 33.7297 38.2494L36.988 41.5078L44.2697 34.2261C44.6805 33.8153 45.3605 33.8153 45.7714 34.2261C46.1822 34.6369 46.1822 35.3169 45.7714 35.7278L37.7389 43.7603C37.5405 43.9586 37.2714 44.0719 36.988 44.0719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedCard);
export default __webpack_public_path__ + "static/media/completed-card.648ed8bca72e6a2e251e0af83692cb45.svg";
export { ForwardRef as ReactComponent };